// extracted by mini-css-extract-plugin
export var buttonContainer = "_9i-1";
export var fontSizeSelect = "_9i-3";
export var formatSelect = "_9i-2";
export var formats = "_9i-4";
export var hidden = "_9i-5";
export var icon = "_9i-6";
export var select = "_9i-0";